import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const getCallableErrorMessage = (error, fallback) => {
  const backendMessage =
    typeof error?.message === 'string'
      ? error.message.replace(/^FirebaseError:\s*/i, '').trim()
      : '';

  if (backendMessage) {
    return backendMessage;
  }

  if (error?.code === 'functions/unauthenticated') {
    return 'You must be signed in to perform this action.';
  }

  if (error?.code === 'functions/permission-denied') {
    return 'You are not authorized to perform this action.';
  }

  return fallback;
};

export const resetUserPasswordService = async (email) => {
  try {
    const resetUserPassword = httpsCallable(functions, 'resetUserPassword');
    const result = await resetUserPassword({ email });
    return result.data;
  } catch (error) {
    throw new Error(getCallableErrorMessage(error, 'Failed to reset user password.'));
  }
};

export const updateUserRoleService = async (uid, role, name) => {
  try {
    const updateUserRole = httpsCallable(functions, 'updateUserRole');
    const result = await updateUserRole({ uid, role, name });
    return result.data?.user || null;
  } catch (error) {
    throw new Error(getCallableErrorMessage(error, 'Failed to update user role.'));
  }
};

export const toggleUserStatusService = async (uid, isActive) => {
  try {
    const normalizedUid = typeof uid === 'string' ? uid.trim() : '';

    console.log('toggleUserStatusService request:', {
      uid: normalizedUid,
      isActive,
      isActiveType: typeof isActive,
    });

    if (!normalizedUid) {
      throw new Error('User uid is required.');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('User status is required.');
    }

    const toggleUserStatus = httpsCallable(functions, 'toggleUserStatus');
    const result = await toggleUserStatus({ uid: normalizedUid, isActive });

    console.log('toggleUserStatusService response:', {
      success: result.data?.success === true,
      uid: result.data?.user?.uid || null,
      isActive: result.data?.user?.isActive,
    });

    return result.data?.user || null;
  } catch (error) {
    console.error('toggleUserStatusService error:', error);
    throw new Error(getCallableErrorMessage(error, 'Failed to update user status.'));
  }
};

export const deleteUserAccount = async (uid) => {
  try {
    const deleteUser = httpsCallable(functions, 'deleteUserAccount');
    const result = await deleteUser({ uid });
    return result.data;
  } catch (error) {
    throw new Error(getCallableErrorMessage(error, 'Failed to delete user.'));
  }
};
